import {BaseRouteConfig} from "../../../core/components/router/models/base-route-config";
import {OUTBRAIN_ARGS, ROUTE_NAMES} from "../../../core/consts";
import {SportsDomainService} from "../../../domain/sports/domain-services/sports.domain-service";
import {DASHBOARD} from "../../dashboard-container/dashboard-container.consts";
import {AllScoresRouteMetaDataModel} from "./all-scores-route.meta-data.model";
import {AllScoresMatchModel} from "./all-scores-match-model";
import {AllScoresContainerPlaceholder} from "../components/all-scores-container.placeholder";
import {ReactLazyPreload} from "../../../core/components/router/react-lazy-preload";

export class AllScoresRouteConfig extends BaseRouteConfig {
  static injectables = [SportsDomainService];

  constructor(sportDomainService: SportsDomainService) {
    super({});

    this.name = ROUTE_NAMES.allScores;
    this.path = `/:sportName?/:filter?`;
    this.paths = [`/:sportName/:filter`, `/:sportName`, `/`];
    this.component = ReactLazyPreload(() => import("../components/all-scores-container" /* webpackChunkName: "all-scores-container" */ ));
    this.metadataType = AllScoresRouteMetaDataModel;
    this.matchType = AllScoresMatchModel;
    this.PlaceholderComponent = AllScoresContainerPlaceholder;
    this.outbrainId = OUTBRAIN_ARGS.OUTBRAIN_ID.homePage;

    const sportsUrlNames = sportDomainService.sportUrlNames;

    this.filters = {
      params: {
        sportName: [...sportsUrlNames, DASHBOARD.FILTERS.all, DASHBOARD.FILTERS.live, DASHBOARD.FILTERS.yesterday, DASHBOARD.FILTERS.tomorrow, DASHBOARD.FILTERS.results, DASHBOARD.FILTERS.fixtures],
        filter: [DASHBOARD.FILTERS.all, DASHBOARD.FILTERS.live, DASHBOARD.FILTERS.yesterday, DASHBOARD.FILTERS.tomorrow, DASHBOARD.FILTERS.results, DASHBOARD.FILTERS.fixtures]
      },
      functions: {
        filter: (filter) => {
          const isValid = DASHBOARD.FILTERS.dateRegEx.test(filter)

          return isValid;
        },
        sportName: (filter) => {
          const isValid = DASHBOARD.FILTERS.dateRegEx.test(filter)

          return isValid;
        }
      }
    };
  }
}
